import components from './components/components';
import pages from './pages/pages';
import shared from './shared';

export default {
  pages,
  components,
  shared,
};
